module.exports = __webpack_public_path__ + "static/media/affordable-catering-4.0184df2e.jpg";